// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"19a50ac2","279":"22500dfc","600":"acbd37d8","658":"fee92e9a","761":"f975ee61","787":"a3711c77","841":"f48ec334"}[chunkId] + ".chunk.js";
};